import { render } from "./AuthoringFilters.vue?vue&type=template&id=d08217e4&scoped=true"
import script from "./AuthoringFilters.vue?vue&type=script&lang=js"
export * from "./AuthoringFilters.vue?vue&type=script&lang=js"

import "./AuthoringFilters.vue?vue&type=style&index=0&id=d08217e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d08217e4"]])

export default __exports__